import React from 'react';

export function Radar({
	className,
}: {
	className?: string;
}): JSX.Element {
	return (
		<svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" height="166" width="165"><circle cx="157" cy="9" r="18" fill="#E30713"/><circle cx="156" cy="10" r="33" stroke="#E30713" strokeWidth="15"/><circle cx="156" cy="10" r="58" stroke="#E30713" strokeWidth="12" opacity=".7"/><circle cx="156" cy="10" r="81" stroke="#E30713" strokeWidth="12" opacity=".65"/><circle cx="155.5" cy="9.5" r="105.5" stroke="#E30713" strokeWidth="12" opacity=".5"/><circle cx="156" cy="10" r="129" stroke="#E30713" strokeWidth="9" opacity=".3"/><circle cx="156" cy="10" r="152" stroke="#E30713" strokeWidth="7" opacity=".1"/></svg>
	);
}
